import React from 'react'

function AddIncentive() {
    return (
        <div>
            AddIncentive


        </div>
    )
}

export default AddIncentive
